import React, { createContext, useEffect, useState } from "react";

export interface ClientImages {
  logoUrl: string;
  faviconUrl: string;
  networkLogoUrl: string;
}

const CommonContext = createContext({
  fetchUrl: "",
  setfetchUrl: (fetchUrl: "") => {},
  loader: {} as boolean,
  setLoader: (loader: boolean) => {},
  sessionDataDTO: {} as any,
  setSessionDataDTO: (sessionDataDTO: any) => {},
  isResendOtpClicked: {} as boolean,
  setIsResendOtpClicked: (isResendOtpClicked: boolean) => {},
  issuer: "",
  setIssuer: (issuer: string) => {},
  cardNetwork: 0 as number,
  setCardNetwork: (cardNetwork: number) => {},
  clientImages: null as ClientImages | null,
  setClientImages: (clientImages: ClientImages | null) => {},
  clientName: "",
  setClientName: (clientName: string) => {},
});

function CommonProvider({ children }: any) {
  const [loader, setLoader] = useState(false),
    [sessionDataDTO, setSessionDataDTO] = useState({}),
    [fetchUrl, setfetchUrl] = useState(""),
    [isResendOtpClicked, setIsResendOtpClicked] = useState(true),
    [issuer, setIssuer] = useState(""),
    [cardNetwork, setCardNetwork] = useState<number>(0),
    [clientImages, setClientImages] = useState<ClientImages | null>(null),
    [clientName, setClientName] = useState<string>("");

  useEffect(() => {
    getFetchUrl();
  }, []);

  const getFetchUrl = () => {
    let a = "";
    if (window.location.href.includes("localhost")) {
      a = "http://localhost:8009";
    } else if (window.location.href.includes("acstest.")) {
      a = "https://acstest.creditpluspinelabs.com";
    }else if (window.location.href.includes("acsuat-mea.")) {
      a = "https://acsuat-mea.creditpluspinelabs.com";
    }  
    else if (window.location.href.includes("acsuat.")) {
      a = "https://acsuat.creditpluspinelabs.com";
    } else if(window.location.href.includes("acs-v231-uat.")) {
      a = "https://acs-v231-uat.creditpluspinelabs.com";
    } else if (window.location.href.includes("acs-mea.")) {
      a = "https://acs-mea.creditpluspinelabs.com";
    } else if (window.location.href.includes("acs.")) {
      a = "https://acs.creditpluspinelabs.com";
    } else if (window.location.href.includes("rupayemvtest")) {
      a = "https://rupayemvtest.pineperks.in";
    } else if (window.location.href.includes("rupayemvuat")) {
      a = "https://rupayemvuat.pineperks.in";
    } else if (window.location.href.includes("rupayemv")) {
      a = "https://rupayemv.pineperks.in";
    } else if (window.location.href.includes("rupaytest")) {
      a = "https://rupaytest.pineperks.in";
    } else if (window.location.href.includes("rupayuat")) {
      a = "https://rupayuat.pineperks.in";
    } else if (window.location.href.includes("rupay")) {
      a = "https://rupay.pineperks.in";
    } else if (window.location.href.includes("visatest")) {
      a = "https://visatest.pineperks.in";
    } else if (window.location.href.includes("visauat")) {
      a = "https://visauat.pineperks.in";
    } else if (window.location.href.includes("visa")) {
      a = "https://visa.pineperks.in";
    }
    setfetchUrl(a);
    return a;
  };

  return (
    <CommonContext.Provider
      value={{
        fetchUrl,
        setfetchUrl,
        loader,
        setLoader,
        sessionDataDTO,
        setSessionDataDTO,
        isResendOtpClicked,
        setIsResendOtpClicked,
        issuer,
        setIssuer,
        cardNetwork,
        setCardNetwork,
        clientImages,
        setClientImages,
        clientName,
        setClientName,
      }}
    >
      {children}
    </CommonContext.Provider>
  );
}

export { CommonProvider, CommonContext };
